import React from "react";
import ReactDOM from "react-dom";
import Root from "views/Root";
import { BrowserRouter } from "react-router-dom";
import 'views/shared/style.css'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Root />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
